import { connect } from "react-redux";
import HardwareInstall from "./hardwareInstall";
import { bindActionCreators } from "redux";
import {
  getHardwareInstall,
  postHardwareInstall,
} from "services/redux/installation/hardwareInstall/action";
import { getGateInfo } from "services/redux/installation/handOver/action";
import { documentUploadUrl } from "services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
  hardwareInstallData: state.hardwareInstallReducer.hardwareInstallData,
  gateInfo: state.handOverReducer.gateInfo,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getHardwareInstall,
      getGateInfo,
      documentUploadUrl,
      postHardwareInstall,
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(HardwareInstall);
